import { defaultLocale, type LocaleCode, supportedLocales } from '../../config/locales';

// Determine the rendered page's locale from its URL. Pages under `/<lang>/...`
// are non-default-locale; everything else falls back to the default locale.
// Used by SiteShell to pick the matching site-config variant at render time
// when a single static query returns all locale variants.
export function getLocaleFromPath(pathname: string): LocaleCode {
  const first = pathname.split('/').filter(Boolean)[0];
  if (first && (supportedLocales as readonly string[]).includes(first)) {
    return first as LocaleCode;
  }
  return defaultLocale;
}
